import React from "react";
import "./Maintenance";
import { apiRequest } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import { SECTIONS } from "../../../constants/appConstants";
import moment from "moment";
import { GetSectionPermission } from "../../../utils/helper";

class SeverityIssuesTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SeverityIssuesList: [],
      High: [],
      Medium: [],
      Low: [],
      IgnoreColumns: []
    };
  }

  componentDidMount() {
    this.GetSeverityIssuesListDataByDate(
      this.props.propertyId,
      this.props.endDate,
      this.props.startDate
    );
  }
  componentWillReceiveProps(newProps) {
    if (
      newProps.propertyId != this.props.propertyId ||
      newProps.endDate != this.props.endDate ||
      newProps.startDate != this.props.startDate
    ) {
      this.GetSeverityIssuesListDataByDate(
        newProps.propertyId,
        newProps.endDate,
        newProps.startDate
      );
    }
  }

  /** Severity issues list data by date */
  GetSeverityIssuesListDataByDate = (propertyId, endDate, startDate) => {
    let High = [];
    let Medium = [];
    let Low = [];
    const params = {
      propertyId: propertyId,
      endDate: endDate,
      startDate: startDate
    };

    apiRequest({
      url: API_URL.maintenance.HighSeverityIssueDetails,
      params
    }).then(SeverityIssuesDetails => {
      const AllData = this._groupBy(SeverityIssuesDetails.data);
      AllData.map(item => {
        if ((item[0] || []).JobType == "Incident - High") {
          High = item;
        } else if ((item[0] || []).JobType == "Incident - Medium") {
          Medium = item;
        }
        if ((item[0] || []).JobType == "Incident - Low") {
          Low = item;
        }
      });

      this.setState({
        SeverityIssuesList: AllData,
        IgnoreColumns: SeverityIssuesDetails.ignoreColumns,
        High: High,
        Medium: Medium,
        Low: Low
      });
    });
  };

  /** Group by */
  _groupBy(myArray) {
    const groups = {};
    for (let i = 0; i < myArray.length; i++) {
      const groupName = myArray[i].JobType;
      if (!groups[groupName]) {
        groups[groupName] = [];
      }
      groups[groupName].push(myArray[i]);
    }
    myArray = [];
    for (const groupName in groups) {
      myArray.push(groups[groupName]);
    }
    return myArray;
  }
  render() {
    const { SeverityIssuesList, IgnoreColumns } = this.state;
    const ignoreDescription =
      IgnoreColumns.indexOf("ServiceDescription") !== -1;
    const highSeverityPermission = GetSectionPermission(
      SECTIONS.MAINTENANCE,
      SECTIONS.LIST_OF_OPEN_HIGH_SEVERITY_ISSUES
    );
    const IsHighVisible =
      highSeverityPermission.accessTypeId > 0 &&
      highSeverityPermission.accessTypeId < 4
        ? true
        : false;
    const mediumSeverityPermission = GetSectionPermission(
      SECTIONS.MAINTENANCE,
      SECTIONS.LIST_OF_OPEN_MEDIUM_SEVERITY_ISSUES
    );
    const IsMediumVisible =
      mediumSeverityPermission.accessTypeId > 0 &&
      mediumSeverityPermission.accessTypeId < 4
        ? true
        : false;
    const lowSeverityPermission = GetSectionPermission(
      SECTIONS.MAINTENANCE,
      SECTIONS.LIST_OF_OPEN_LOW_SEVERITY_ISSUES
    );
    const IsLowVisible =
      lowSeverityPermission.accessTypeId > 0 &&
      lowSeverityPermission.accessTypeId < 4
        ? true
        : false;
    const ShowData =
      !ignoreDescription &&
      ((IsHighVisible && highSeverityPermission.showData) ||
        (IsMediumVisible && mediumSeverityPermission.showData) ||
        (IsLowVisible && lowSeverityPermission.showData));

    return (
      <>
        {IsHighVisible && (
          <div>
            {" "}
            <table id={"SeverityIssuesTable"}>
              <thead>
                <tr className={"blue-custom-title"}>
                  <th colSpan={6}>{"List of Open High Severity Issues "}</th>
                </tr>
                <tr className={"blue-custom-title"} style={{ textAlign: "left" }}>
                  <th className={"w-10"} title={"Work Order ID"}>
                    {"WO ID"}{" "}
                  </th>
                  <th className={"w-15"}>{"Data Center "}</th>
                  <th className={"w-15"}>{"Service Location "}</th>
                  <th className={"w-15"}>{"Date Added "}</th>
                  <th className={"w-15"}>{"Status "}</th>
                  {ShowData && <th className={"w-80"}>{"Description"}</th>}
                </tr>
              </thead>
              <tbody>
                {(this.state.High || []).length > 0 ? (
                  (SeverityIssuesList || []).map(item =>
                    (item || []).map((item, index) =>
                      item.JobType == "Incident - High" ? (
                        <tr key={"SeverityIssuesList" + index}>
                          <td style={{ fontSize: "13px", lineHeight: "1.2" }}>
                            {item["WorkOrderId"] != null
                              ? item["WorkOrderId"]
                              : "-"}
                          </td>
                          <td>{item["Property"]}</td>
                          <td>{item["ServiceLocation"]}</td>
                          <td>
                            {moment(item["ReceivedDate"]).format("MM-DD-YYYY")}
                          </td>
                          <td>
                            {item["WorkOrderStatus"] != null
                              ? item["WorkOrderStatus"]
                              : "-"}
                          </td>
                          {ShowData && (
                            <td style={{ fontSize: "13px", lineHeight: "1.2" }}>
                              {item["ServiceDescription"] != null
                                ? item["ServiceDescription"]
                                : "-"}
                            </td>
                          )}
                        </tr>
                      ) : null
                    )
                  )
                ) : (this.state.High || []).length <= 0 ? (
                  <tr>
                    <td colSpan={"6"} style={{ textAlign: "center" }}>
                      {" "}
                      {"No data available\r"}
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        )}

        {IsMediumVisible && (
          <div style={{ marginTop: "10px" }}>
            {" "}
            <table id={"SeverityIssuesTable"}>
              <thead>
                <tr className={"blue-custom-title"}>
                  <th colSpan={6}>{"List of Open Medium Severity Issues "}</th>
                </tr>
                <tr className={"blue-custom-title"} style={{ textAlign: "left" }}>
                  <th className={"w-10"} title={"Work Order ID"}>
                    {"WO ID"}{" "}
                  </th>
                  <th className={"w-15"}>{"Data Center "}</th>
                  <th className={"w-15"}>{"Service Location "}</th>
                  <th className={"w-15"}>{"Date Added "}</th>
                  <th className={"w-15"}>{"Status "}</th>
                  {ShowData && <th className={"w-80"}>{"Description"}</th>}
                </tr>
              </thead>
              <tbody>
                {(this.state.Medium || []).length > 0 ? (
                  (SeverityIssuesList || []).map(item =>
                    (item || []).map((item, index) =>
                      item.JobType == "Incident - Medium" ? (
                        <tr key={"SeverityIssuesList" + index}>
                          <td style={{ fontSize: "13px", lineHeight: "1.2" }}>
                            {item["WorkOrderId"] != null
                              ? item["WorkOrderId"]
                              : "-"}
                          </td>
                          <td>{item["Property"]}</td>
                          <td>{item["ServiceLocation"]}</td>
                          <td>
                            {moment(item["ReceivedDate"]).format("MM-DD-YYYY")}
                          </td>
                          <td>
                            {item["WorkOrderStatus"] != null
                              ? item["WorkOrderStatus"]
                              : "-"}
                          </td>
                          {ShowData && (
                            <td style={{ fontSize: "13px", lineHeight: "1.2" }}>
                              {item["ServiceDescription"] != null
                                ? item["ServiceDescription"]
                                : "-"}
                            </td>
                          )}
                        </tr>
                      ) : null
                    )
                  )
                ) : (this.state.Medium || []).length <= 0 ? (
                  <tr>
                    <td colSpan={"6"} style={{ textAlign: "center" }}>
                      {" "}
                      {"No data available\r"}
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        )}

        {IsLowVisible && (
          <div style={{ marginTop: "10px" }}>
            {" "}
            <table id={"SeverityIssuesTable"}>
              <thead>
                <tr className={"blue-custom-title"}>
                  <th colSpan={6}>{"List of Open Low Severity Issues "}</th>
                </tr>
                <tr className={"blue-custom-title"} style={{ textAlign: "left" }}>
                  <th className={"w-10"} title={"Work Order ID"}>
                    {"WO ID"}{" "}
                  </th>
                  <th className={"w-15"}>{"Data Center "}</th>
                  <th className={"w-15"}>{"Service Location "}</th>
                  <th className={"w-15"}>{"Date Added "}</th>
                  <th className={"w-15"}>{"Status "}</th>
                  {ShowData && <th className={"w-80"}>{"Description"}</th>}
                </tr>
              </thead>
              <tbody>
                {(this.state.Low || []).length > 0 ? (
                  (SeverityIssuesList || []).map(item =>
                    (item || []).map((item, index) =>
                      item.JobType == "Incident - Low" ? (
                        <tr key={"SeverityIssuesList" + index}>
                          <td style={{ fontSize: "13px", lineHeight: "1.2" }}>
                            {item["WorkOrderId"] != null
                              ? item["WorkOrderId"]
                              : "-"}
                          </td>
                          <td>{item["Property"]}</td>
                          <td>{item["ServiceLocation"]}</td>
                          <td>
                            {moment(item["ReceivedDate"]).format("MM-DD-YYYY")}
                          </td>
                          <td>
                            {item["WorkOrderStatus"] != null
                              ? item["WorkOrderStatus"]
                              : "-"}
                          </td>
                          {ShowData && (
                            <td style={{ fontSize: "13px", lineHeight: "1.2" }}>
                              {item["ServiceDescription"] != null
                                ? item["ServiceDescription"]
                                : "-"}
                            </td>
                          )}
                        </tr>
                      ) : null
                    )
                  )
                ) : (this.state.Low || []).length <= 0 ? (
                  <tr>
                    <td colSpan={"6"} style={{ textAlign: "center" }}>
                      {" "}
                      {"No data available\r"}
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        )}
      </>
    );
  }
}
export default SeverityIssuesTable;
